export enum TestingDirection {
    NotAvailable = 0,
    Increasing,
    Decreasing
}
